<template>
<div>
    <v-card dark class="pa-4 grey darken-3 ma-4">

        <v-toolbar dark flat dense class="grey darken-3 ma-4">
            <v-toolbar-title>Коди Megogo Епіцентр</v-toolbar-title>
            <v-btn icon @click="getDataFromApi()" title="Оновити">
                <v-icon color="grey">mdi-cached</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="dateFrom" label="Дата з" append-icon="mdi-calendar" v-on="on" hide-details readonly></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom" @input="menu1 = false"></v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="dateTo" label="Дата по" append-icon="mdi-calendar" v-on="on" hide-details readonly></v-text-field>
                </template>
                <v-date-picker v-model="dateTo" @input="menu2 = false"></v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn small text @click="exportData()" class="megogo--text">
                В Excel <v-icon class="pl-3">mdi-export</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-data-table :headers="headers" item-key="code" :items="list" :footer-props="footerProps" :search="search" class="ma-4">
                <template v-slot:no-data>
                    ...
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

export default {
    data() {
        return {
            f: {},
            usersTable: false,
            search: '',
            dateFrom: null,
            dateTo: null,
            menu1: null,
            menu2: null,
            footerProps: {
                'items-per-page-options': [20, 40, 100],
                'items-per-page-text': 'на стор.'
            },
            headers: [{
                    text: 'Код',
                    align: 'left',
                    sortable: false,
                    value: 'code',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Пакет',
                    align: 'left',
                    sortable: true,
                    value: 'service_type',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Цифровой код',
                    align: 'left',
                    sortable: false,
                    value: 'service_key',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Статус',
                    align: 'left',
                    sortable: true,
                    value: 'status_code',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Дата',
                    align: 'left',
                    sortable: true,
                    value: 'ctime',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Телефон покупця',
                    align: 'left',
                    sortable: false,
                    value: 'phone',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Документ T22',
                    align: 'left',
                    sortable: true,
                    value: 'typhoon_doc',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Документ продажу',
                    align: 'left',
                    sortable: true,
                    value: 'typhoon_doc',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Дата продажу',
                    align: 'left',
                    sortable: true,
                    value: 'sales_date',
                    selected: false,
                    width: '10%',
                    filter: value => {
                        if (!this.dateFrom && !this.dateTo) return true
                        const lDate = new Date(value)
                        const fromDate = this.dateFrom ? new Date(this.dateFrom) : new Date('2000-01-01')
                        const toDate = this.dateTo ? new Date(this.dateTo) : new Date()
                        return lDate >= fromDate && lDate <= toDate
                    }
                },

            ]
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'touch', 'getEpicentrkMegogoCodes','getEpicentrkMegogoCodesExport','createXlsx']),
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
        },
        getDataFromApi() {
            this.search = ''
            this.dateTo = null
            this.dateFrom = null

            this.getEpicentrkMegogoCodes()
        },
        exportData() {
            this.getEpicentrkMegogoCodesExport({
                    search: this.search,
                    dateTo: this.dateTo,
                    dateFrom: this.dateFrom,
                })
                .then(data => {
                    this.createXlsx(data)
                        .then(
                            () => {
                                this.openExport = false
                                window.open(process.env.NODE_ENV === 'production' ? '/api/xlsx/file/Report.xlsx' : 'http://dev.extraservices.com.ua:3003/api/xlsx/file/Report.xlsx')
                            }
                        )
                })
                .catch(error => this.setSnackbar(['error', error]))
        },
    },
    created() {
        this.getDataFromApi()
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.epicentrkMegogoCodesList || []
        },
    },
    watch: {}
}
</script>

<style>
.inp-cnt {
    color: black;
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid rgb(7, 0, 0);
    width: 40px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}
</style>
